import * as CONSTANTS from '../modules/constants';

export function stickyHeader() {
    window.addEventListener('load', function() {
        const header = document.getElementById('siteHeader');
        const calendarList = document.querySelector('.calendar-container');
        const calendarFilters = document.getElementById('calendar-filters');
        const siteBody = document.body;

        let headerDimensions = header.offsetHeight;
        let calendarFiltersDimensions;
        let lastScrollTop = 0;

        if (calendarFilters != null) {
            calendarFiltersDimensions = calendarFilters.offsetHeight;
        }

        function initMobileSticky() {
            // Handle header compensation on smaller screens
            if (window.matchMedia('(max-width: 768px)').matches) {
                headerDimensions = header.offsetHeight;

                // compensate for fixed header on small screens
                //siteBody.style.paddingTop = headerDimensions + "px";

                if (calendarFilters != null) {
                    calendarFiltersDimensions = calendarFilters.offsetHeight;

                    // set calendar filters to be sticky by default on small screens
                    calendarFilters.classList.add('sticky-top');
                    calendarFilters.style.transform = 'translateY(' + headerDimensions + 'px)';
                    (calendarList as HTMLElement).style.paddingTop = calendarFiltersDimensions + 'px';
                }
            }
        }

        initMobileSticky();

        function resetOffsets() {
            headerDimensions = header.offsetHeight;

            if (calendarFilters != null) {
                calendarFiltersDimensions = calendarFilters.offsetHeight;
            }
        }

        function stickyDisplayHandler() {
            // only run on larger screens
            if (window.matchMedia('(min-width: 769px)').matches) {
                var currentPos = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"

                headerDimensions = header.offsetHeight;

                if (calendarFilters != null) {
                    calendarFiltersDimensions = calendarFilters.offsetHeight;
                }

                // handle calendar sticky
                if (calendarFilters != null && currentPos > headerDimensions) {
                    calendarFilters.classList.add('sticky-top');
                    (calendarList as HTMLElement).style.paddingTop = calendarFiltersDimensions + 'px';
                }

                // handle header sticky
                if (currentPos === 0) {
                    if (!CONSTANTS.GLOBAL_BODY.classList.contains('locked')) {
                        header.classList.add('sticky-show');
                        header.style.top = '0px';
                        header.classList.remove('sticky-top');

                        //siteBody.classList.remove('sticky-header');
                        //siteBody.style.paddingTop = "0px";

                        if (calendarFilters != null) {
                            calendarFilters.style.transform = 'translateY(0px)';
                            calendarFilters.classList.remove('sticky-top');
                            (calendarList as HTMLElement).style.paddingTop = '0px';
                        }
                    }
                } else if (currentPos > lastScrollTop && currentPos > headerDimensions) {
                    if (!CONSTANTS.GLOBAL_BODY.classList.contains('locked')) {
                        // downscroll code
                        header.classList.add('sticky-top');
                        header.classList.remove('sticky-show');
                        header.style.top = '-' + headerDimensions + 'px';

                        //siteBody.classList.add('sticky-header');
                        //siteBody.style.paddingTop = headerDimensions + "px";

                        if (calendarFilters != null) {
                            calendarFilters.style.transform = 'translateY(0px)';
                        }
                    }
                } else if (currentPos < lastScrollTop && currentPos > headerDimensions) {
                    if (!CONSTANTS.GLOBAL_BODY.classList.contains('locked')) {
                        // upscroll code
                        header.classList.add('sticky-show');
                        header.style.top = '0px';

                        if (calendarFilters != null) {
                            calendarFilters.style.transform = 'translateY(' + headerDimensions + 'px)';
                        }
                    }
                }

                // set current position to lastScrollTop
                lastScrollTop = currentPos;
            }
        }

        window.addEventListener('resize', () =>
            window.requestAnimationFrame(() => {
                initMobileSticky();
                stickyDisplayHandler();
            })
        );

        window.addEventListener('scroll', () =>
            window.requestAnimationFrame(() => {
                stickyDisplayHandler();
            })
        );
    });
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/sticky-header.ts